import React, { Component } from 'react';
import { connect } from 'react-redux';
import lightOrDark from '../SlickArrow/colorArrowFunction';
import { css } from '@emotion/core';

class FidelityPointsEarned extends Component {
  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  calculateEarnedPoints = () => {
    const { fidelityPointsFarmaci, fidelityPointsAmount, cart } = this.props;

    const farmaci = cart.filter(
      product => product.type === 'farmaci' || product.taxCreditType === 'DRUG'
    );
    const totalPoints = fidelityPointsAmount * this.renderCartTotal();
    const farmaciTotalPrice = farmaci.reduce(
      (total, product) => total + product.price,
      0
    );

    const earnedPoints = fidelityPointsFarmaci
      ? parseInt(totalPoints)
      : parseInt(totalPoints - farmaciTotalPrice);

    return earnedPoints;
  };

  render() {
    const { primaryColor } = this.props;
    const earnedPoints = this.calculateEarnedPoints();

    const style = css`
      color: black;
      font-size: 14px;
      margin-right: 12px;
      text-align: center;

      @media (max-width: 1150px) {
        color: ${lightOrDark(primaryColor) === 'light' ? 'black' : 'white'};
        margin-right: 0;
      }
    `;

    return (
      <div css={style}>
        Questo acquisto ti farà guadagnare{' '}
        <span style={{ fontSize: 16 }}>💎</span>{' '}
        <b>{earnedPoints} Fidelity points</b>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    fidelityPointsAmount: state.store.data.fidelityPoints.currencyAmount,
    fidelityPointsFarmaci: !!state.store.data.fidelityPoints.enableSopOtc,
  };
};

export default connect(mapStateToProps)(FidelityPointsEarned);
